import HttpClient from "../../clients/HttpClient";
import Offer from "../../models/Offer";
import { dateEndOfLocalDay, dateStartOfLocalDay } from "../../utils/dates";

export default class OffersService {
    static httpClient: HttpClient = HttpClient.getInstance("backend", process.env.REACT_APP_API_URL);

    public static async list(params = {}): Promise<Array<Offer>> {
        return this.httpClient.get("/offers", params).then((res) => {
            return res.data.map((row) => new Offer(row));
        });
    }

    public static async getOffer(id): Promise<Offer> {
        return this.httpClient.get(`/offers/${id}`).then((res) => {
            return new Offer(res.data);
        });
    }

    public static async addOffer(data): Promise<Offer> {
        // Placing these here in service layer due to GenericTable and GenericForm has no way to inject code
        // before add/edit is called on the service.
        data.startDate = data.startDate ? dateStartOfLocalDay(data.startDate) : null;
        data.endDate = data.endDate ? dateEndOfLocalDay(data.endDate) : null;
        data.voucherName = data.voucherName ? JSON.stringify(data.voucherName) : null;

        return this.httpClient.post(`/offers`, data).then((res) => {
            return new Offer(res.data);
        });
    }

    public static async editOffer(id, data): Promise<Offer> {
        // Placing these here in service layer due to GenericTable and GenericForm has no way to inject code
        // before add/edit is called on the service.
        data.startDate = data.startDate ? dateStartOfLocalDay(data.startDate) : null;
        data.endDate = data.endDate ? dateEndOfLocalDay(data.endDate) : null;
        data.voucherName = data.voucherName ? JSON.stringify(data.voucherName) : null;

        return this.httpClient.put(`/offers/${id}`, data).then((res) => {
            return new Offer(res.data);
        });
    }

    public static async deleteOffer(id): Promise<boolean> {
        return this.httpClient.delete(`/offers/${id}`, null).then((res) => {
            return true;
        });
    }
}

